export const LOGISTICS_DRIVER_STATUS_ONLINE = "online";

export interface LogisticsDealerDriverDto {
  id: string;
  name: string;
  enabled: boolean;
  status: string;
  createdAt?: string;
  modifiedAt?: string;
  dealer: {
    id: string;
  };
}

export interface LogisticsDealerDriversResponseDto {
  data: LogisticsDealerDriverDto[];
}

export interface GetDealerDriversParams {
  dealerId: string;
  limit?: number;
  keyset?: string;
  statuses?: string[];
}
